export { default as PanelTitle } from './panel-title';
